import React from 'react';
import CreatePrenupForm from './CreatePrenupForm';

const CreatePrenup = () => {
  return <CreatePrenupForm />;
};

export default CreatePrenup;
